import(/* webpackMode: "eager" */ "/app/src/components/UniversalComponent/UniversalComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["COMPONENTS_CONFIG"] */ "/app/src/constants/componentsConfig.ts");
;
import(/* webpackMode: "eager" */ "/app/src/hooks/useBreakpoints/breakpointsContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useAzureConfig"] */ "/app/src/services/azureConfiguration/useAzureConfigHook.ts");
